/** Contrato puro compartido por SSR y directivas: ninguna lectura de DOM/UA global. */
export const HERO_IMAGE_WIDTH_MOVIL = 412;
export const HERO_IMAGE_WIDTH_ESCRITORIO = 600;
export const IMAGE_ORIGIN = /^https:\/\/img\.michollo\.com\//i;

// Shared by the feed, its SSR skeleton and the responsive preload.
export const FEED_IMAGE_WIDTHS = [96, 128, 192, 256, 288, 384] as const;
export const FEED_IMAGE_SIZES = '(max-width: 992px) 96px, 128px';

/** Only real resize routes/formats; external images and animations stay untouched. */
export function imageSrcset(url: string, widths: readonly number[], webp = true): string | null {
  if (!url || !/^https:\/\/img\.michollo\.com\/(?:r\/\d+\/)*(?:app|deals)\/[^?#]+\.(?:jpe?g|png|webp)(?:[?#]|$)/i.test(url)) return null;
  const candidates = [...new Set((widths || []).filter(width => Number.isInteger(width) && width > 0 && width <= 1920))].sort((a, b) => a - b);
  if (candidates.length < 2) return null;
  // Whitespace and commas would otherwise be interpreted as srcset separators.
  const source = (webp ? webpImageUrl(url) : url).replace(/[\s,]/g, encodeURIComponent);
  return candidates.map(width => `${imageWidthUrl(source, width)} ${width}w`).join(', ');
}

export function imageWidthUrl(url: string, width: number): string {
  if (!url || !IMAGE_ORIGIN.test(url) || !Number.isInteger(width) || width < 1) return url;
  // Consumir todos los prefijos también repara URLs antiguas transformadas dos veces.
  return url.replace(/^(https:\/\/img\.michollo\.com\/)(?:(?:r\/\d+\/)+|(?=app\/|deals\/))/i, `$1r/${width}/`);
}

export function webpImageUrl(url: string): string {
  if (!url) return url;
  const cut = url.search(/[?#]/);
  const path = cut < 0 ? url : url.slice(0, cut);
  const suffix = cut < 0 ? '' : url.slice(cut);
  return path.replace(/\.(png|jpe?g)$/i, '.webp') + suffix;
}

export function heroWidth(mobile: boolean): number {
  return mobile ? HERO_IMAGE_WIDTH_MOVIL : HERO_IMAGE_WIDTH_ESCRITORIO;
}

/** Stable variants for card upgrades; fixed SSR/preload URLs keep their own width. */
export const IMAGE_WIDTHS = [30, 60, 80, 108, 120, 166, 190, 216, 249, 300, 340, 412, 480, 600, 800, 1024, 1280, 1600, 1920] as const;
export function imageVariantWidth(width: number): number {
  if (!Number.isFinite(width) || width <= 0) return 0;
  return IMAGE_WIDTHS.find(value => value >= width) || IMAGE_WIDTHS[IMAGE_WIDTHS.length - 1];
}
export function originalImageUrl(url: string): string {
  return url?.replace(/^(https:\/\/img\.michollo\.com\/)(?:r\/\d+\/)+/i, '$1');
}
